import { render } from "./LanguageToggle.vue?vue&type=template&id=2b843a2a"
import script from "./LanguageToggle.vue?vue&type=script&lang=js"
export * from "./LanguageToggle.vue?vue&type=script&lang=js"

import "./LanguageToggle.vue?vue&type=style&index=0&id=2b843a2a&lang=scss"

import exportComponent from "/builds/lindner/lindner-factorytour-frontend-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__